import React from 'react';

const SupportDashboard = () => {
  return (
    <div style={{ padding: '24px' }}>
      <h1>Support Dashboard</h1>
      <p>Support ticket management coming soon...</p>
    </div>
  );
};

export default SupportDashboard;
